import { takeLatest, call, put, select, all } from 'redux-saga/effects';

import Selectors from './account-template-selectors';
import Actions from './account-template-actions';
import Api from './account-template-api';

function* fetchHandler({ payload }) {
  const lastQuery = yield select(Selectors.lastQuery);
  const mergedQuery = { ...lastQuery, ...payload };
  const accountTemplates = yield call(
    Api.fetch,
    { ...mergedQuery } // the payload may be used to override the query paramd we send
  );

  if (accountTemplates.error) yield put(Actions.fetchFailure(accountTemplates.error));
  else {
    yield put(Actions.fetchSuccess(accountTemplates, { lastQuery: mergedQuery }));
  }
}

export default function* accountTemplatesSaga() {
  yield all([takeLatest(Actions.fetch.getType(), fetchHandler)]);
}
